export default "__VITE_ASSET__DpMiWIC___"